import { cqrs } from '@faro/http-clients';
import { NamedObject } from '@faro/study-designer-model';
import { StudyPathParameter } from '../parameter';

export type ObjectiveTypePathParameters = StudyPathParameter;

export const objectiveTypeClient = cqrs<NamedObject, ObjectiveTypePathParameters>(
    '/api/study-designer/studies/:studyId/objective-types',
    // faro-common-model toNamedObject can return undefined so this defines a custom mapper
    (value: any) =>
        (value?.id != null
            ? {
                  id: value.id,
                  name: value.name,
              }
            : { name: value.name }) as NamedObject
).listableEntityClient();
